/* Configure logo, favicon, styles, document title based on current brand
 * */
const MALDOPAY_ORGANISATION_NAME = "MaldoPay";
const MALDOPAY_SECRET_BUSINESS_ID = "3b486c7a-497f-42a0-abce-993292f8962e";
const organisationsWithGbpSettlement = ["cf1e67d0-46f6-4a00-8370-090a5087c80f"];
const organisationsWithUsdSettlement = ["cf1e67d0-46f6-4a00-8370-090a5087c80f"];

const businessPermissions = ["GET_BUSINESS", "GET_BUSINESSES"];
const balancesStatisticsPermissions = ["GET_STATISTICS", "GET_BALANCE", "GET_BALANCES"];

const AppConfig = {
  showInfoSections: false,
  loadedBrand: {},
  brands: Object.freeze({
    FINRAX_LT: { value: "FINRAX_LT", fiatDepositAllowed: true },
    SANDBOX_FINRAX_LT: { value: "SANDBOX_FINRAX_LT", fiatDepositAllowed: true },
    NAEWE_CR: { value: "NAEWE_CR", fiatDepositAllowed: true },
    SANDBOX_NAEWE_CR: { value: "SANDBOX_NAEWE_CR", fiatDepositAllowed: true },
    B2BPAY: { value: "B2BPAY", fiatDepositAllowed: false },
    VIRAPAY: { value: "VIRAPAY", fiatDepositAllowed: false },
    MALDO: { value: "MALDO", fiatDepositAllowed: false },
    AXOM_FINRAX: { value: "AXOM_FINRAX", fiatDepositAllowed: false },
    AXOM: { value: "AXOM", fiatDepositAllowed: false },
    MONOLO: { value: "MONOLO", fiatDepositAllowed: false },
    DIGIBLOX: { value: "DIGIBLOX", fiatDepositAllowed: true },
    NORDEPAY: { value: "NORDEPAY", fiatDepositAllowed: false },
    NUVEPAY: { value: "NUVEPAY", fiatDepositAllowed: false },
    DEVELOPMENT_FINRAX: { value: "DEVELOPMENT_FINRAX", fiatDepositAllowed: true },
    DEVELOPMENT_NAEWE: { value: "DEVELOPMENT_NAEWE", fiatDepositAllowed: false },
    DEVELOPMENT_LOCAL: { value: "DEVELOPMENT_LOCAL", fiatDepositAllowed: true },
    LOCAL: { value: "LOCAL", fiatDepositAllowed: true },
  }),
  setFavicon(iconUrl) {
    let link = document.createElement("link")
    link.rel = "icon"
    link.href = iconUrl
    document.head.appendChild(link)
  },
  styles: {
    primaryColor: "#005550",
    userRole: "#15FAA8",
    sidebarColor: "#FFF",
    sidebarHeaders: "#34C159",
    withdrawalColor: "#EF843D",
    positiveButtonAction: "#00c478",
    buttonTextColor: "#FFF",
  },
  setTheme(theme) {
    this.styles = theme
  },
  setDocumentTitle() {
    switch (this.loadedBrand) {
      case this.brands.AXOM_FINRAX:
      case this.brands.AXOM:
        document.title = "Axom Dashboard";
        break;
      case this.brands.B2BPAY:
        document.title = "B2BPAY Dashboard";
        break;
      case this.brands.DIGIBLOX:
        document.title = "DigiBlox Dashboard";
        break;
      case this.brands.SANDBOX_FINRAX_LT:
        document.title = "Finrax Dashboard (sandbox)";
        break;
      case this.brands.FINRAX_LT:
        document.title = "Finrax Dashboard";
        break;
      case this.brands.SANDBOX_NAEWE_CR:
        document.title = "Naewe Dashboard (sandbox)";
        break;
      case this.brands.NAEWE_CR:
        document.title = "Naewe Dashboard";
        break;
      case this.brands.LOCAL:
      case this.brands.DEVELOPMENT_LOCAL:
        document.title = "Finrax Dashboard (local)";
        break;
      case this.brands.DEVELOPMENT_FINRAX:
        document.title = "Finrax Dashboard (dev)";
        break;
      case this.brands.DEVELOPMENT_NAEWE:
        document.title = "Naewe Dashboard (dev)";
        break;
      case this.brands.MALDO:
        document.title = "MaldoCrypto Dashboard";
        break;
      case this.brands.MONOLO:
        document.title = "Monolo Dashboard";
        break;
      case this.brands.VIRAPAY:
        document.title = "ViraPay Dashboard";
        break;
      case this.brands.NORDEPAY:
        document.title = "Nordepay Dashboard";
        break;
      case this.brands.NUVEPAY:
        document.title = "Nuvepay Dashboard";
        break;
      default:
        document.title = "Dashboard";
        break;
    }
  },
  customers: {
    MALDOPAY_ORGANISATION_NAME,
    MALDOPAY_SECRET_BUSINESS_ID,
    organisationsWithGbpSettlement,
    organisationsWithUsdSettlement,
  },
  paymentType: {
    DEPOSITS: "Deposits",
    WITHDRAWALS: "Withdrawals",
    SETTLEMENTS: "Settlements",
    FIAT_TOP_UPS: "FiatTopUps",
    TRANSFERS: "Transfers",
    UNASSOCIATED_DEPOSITS: "UnassociatedDeposits",
    MANUAL_LEDGER_MOVEMENTS: "ManualLedgerMovements",
    STATISTICS: "Statistics",
    UNALLOCATED: "Unallocated",
    BALANCE_CONVERSIONS: "BalanceConversions",
  },
  getOverpayScenario(shouldRefund) {
    return shouldRefund ? this.overpayScenarios.refund : this.overpayScenarios.process;
  },
  overpayScenarios: {
    process: "PROCESS",
    refund: "EXCESS_REFUND",
  },
  userRoles: {
    SUPPORT: "SUPPORT",
    BACKOFFICE: "BACKOFFICE",
    MANAGER: "MANAGER",
    ADMIN: "ADMIN",
  },
  defaultPermissions: ["GET_ORGANISATION"],
  permissions: [
    {
      name: "Manage businesses",
      view: [],
      full: [...businessPermissions, ...balancesStatisticsPermissions, "CREATE_BUSINESS", "UPDATE_BUSINESS"],
    },
    {
      name: "View statistics",
      view: [],
      full: [...balancesStatisticsPermissions],
    },
    {
      name: "Manage payments",
      view: ["GET_PAYMENT", "GET_PAYMENTS", "INITIATE_CALLBACK", ...businessPermissions],
      full: [
        "GET_PAYMENT",
        "GET_PAYMENTS",
        "INITIATE_CALLBACK",
        ...businessPermissions,
        ...balancesStatisticsPermissions,
        "CREATE_PAYMENT",
      ],
    },
    {
      name: "Manage withdrawals",
      view: ["GET_WITHDRAWALS", ...businessPermissions],
      full: ["CREATE_WITHDRAWAL", "GET_WITHDRAWALS", ...businessPermissions, ...balancesStatisticsPermissions],
    },
    {
      name: "Manage internal transfers",
      view: ["GET_INTERNAL_TRANSFERS", "FETCH_MANUAL_MOVEMENTS", ...businessPermissions],
      full: [
        "GET_INTERNAL_TRANSFERS",
        "CREATE_INTERNAL_TRANSFER",
        "FETCH_MANUAL_MOVEMENTS",
        ...businessPermissions,
        ...balancesStatisticsPermissions,
      ],
    },
    {
      name: "Manage bank accounts",
      view: ["FETCH_BANK_METADATA", "FETCH_BANK_ACCOUNTS"],
      full: ["FETCH_BANK_METADATA", "FETCH_BANK_ACCOUNTS", "MANAGE_BANK_ACCOUNTS"],
    },
    {
      name: "Manage fiat top-ups",
      view: ["GET_FIAT_DEPOSITS", ...businessPermissions],
      full: [
        "GET_FIAT_DEPOSITS",
        "CREATE_FIAT_DEPOSIT",
        "FETCH_BANK_ACCOUNTS",
        ...businessPermissions,
        ...balancesStatisticsPermissions,
      ],
    },
    {
      name: "Manage bank settlements",
      view: ["GET_FIAT_WITHDRAWALS", ...businessPermissions],
      full: [
        "GET_FIAT_WITHDRAWALS",
        "CREATE_FIAT_WITHDRAWAL",
        "FETCH_BANK_METADATA",
        "FETCH_BANK_ACCOUNTS",
        ...businessPermissions,
        ...balancesStatisticsPermissions,
      ],
    },
    {
      name: "Manage balance conversions",
      view: ["GET_BALANCE_CONVERSIONS", ...businessPermissions],
      full: [
        "CREATE_BALANCE_CONVERSION",
        "GET_BALANCE_CONVERSIONS",
        ...businessPermissions,
        ...balancesStatisticsPermissions,
      ],
    },
    {
      name: "Manage API keys",
      view: ["GET_API_CREDENTIALS"],
      full: ["GET_API_CREDENTIALS", "CREATE_API_CREDENTIALS", "UPDATE_API_CREDENTIALS", "DELETE_API_CREDENTIALS"],
    },
    {
      name: "Manage whitelisted addresses",
      view: [],
      full: ["WHITELIST_ADDRESSES"],
    },
    {
      name: "Manage users and roles",
      view: [],
      full: ["MANAGE_ROLES", "CREATE_USER", "UPDATE_USER", "DELETE_USER", "GET_USERS"],
    },
    {
      name: "Manage travel rule",
      view: ["GET_DEPOSITS_WITHOUT_TRAVEL_RULE"],
      full: ["GET_DEPOSITS_WITHOUT_TRAVEL_RULE", "UPDATE_DEPOSITS_WITHOUT_TRAVEL_RULE"],
    },
  ],
  erc20tokens: [
    "ETH",
    "AION",
    "BAT",
    "BNT",
    "CVC",
    "ENJ",
    "FUN",
    "KNC",
    "LINK",
    "LRC",
    "MITH",
    "MTL",
    "OMG",
    "REP",
    "ZIL",
    "USDT",
    "USDC",
  ],
  cryptoSettlementCurrencies: ["USDT", "USDC", "BTC"],
  nonErc20tokens: ["BTC", "BCH", "LTC", "XLM", "XRP", "EOS", "DASH"],
  blockchainPathsMapping: {
    BTC: "bitcoin",
    BCH: "bitcoin-cash",
    LTC: "litecoin",
    XLM: "stellar",
    XRP: "ripple",
    EOS: "eos",
    DASH: "dash",
  },
  humanReadableNetworks: {
    MAIN: "Main network",
    BSC: "Binance Smart Chain (BEP20)",
    TRX: "Tron Network (TRC20)",
    ETH: "Ethereum network (ERC20)",
    SOL: "Solana network (SPL)",
  },
};

module.exports = AppConfig;
